<template>
    <div id="white-list">
        <supsis-table :columns="cols()" :rows="getFilteredRows()">
            <template #header>
                <div class="d-flex justify-content-between align-items-center">
                    <a-input-search
                        v-model="searchText"
                        :placeholder="$t('message.search')"
                        class="search-input"
                        @search="onSearch"
                    />
                    <div class="page-header">
                        <div class="title">{{ $t("message.accessControl") }}</div>
                        <div class="subtitle">{{ $t("settings.accessControlSubTitles") }}</div>
                    </div>
                    <SupsisButton ghost @click="showModalWithoutEdit">
                        {{ $t('settings.whiteListAdd') }}
                        <md-icon>add</md-icon>
                    </SupsisButton>
                </div>
            </template>
        </supsis-table>
        <Modal2
            v-if="isModalShow"
            id="white-list-form"
            :title="$t('settings.whiteList')"
            @cancel="hideModal"
            :show-footer="false"
        >
            <div class="form-group">
                <label for="ipAddress">{{$t("message.ipAddress")}}</label>
                <div class="ip-address">
                    <a-input v-model="form.ipAddress" id="ipAddress" placeholder="0.0.0.0" />
                    <SupsisButton @click="takeIpAddress" primary class="detect-ip-btn">
                        {{ $t('settings.detectIpAddress') }}
                    </SupsisButton>
                </div>
            </div>
            <div class="form-group">
                <label for="description">{{ $t('tables.description') }}</label>
                <a-input v-model="form.description" id="description" />
            </div>
            <div class="d-flex justify-content-end">
                <SupsisButton @click="handleSave" primary> {{ $t('message.save') }} </SupsisButton>
            </div>
        </Modal2>
    </div>
</template>

<script>
import { log2 } from "../../../../../utils/log2";
import ActionEdit from "../../../../../components/svg/ActionEdit.vue";
import ActionDelete from "../../../../../components/svg/ActionDelete.vue";
import Pagination from "../../../../../components/Pagination.vue";
import MultiContent from "../../../../../components/MultiContent.vue";
import Modal2 from "../../../../../components/common/Modal2.vue";
import SupsisTable from "../../../../../components/SupsisTable.vue";
import SupsisButton from "../../components/SupsisButton.vue";
import CreateButton from "../../../../../components/CreateButton.vue";
import { WHITE_LIST_API } from "../../../../../api/whitelist";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faPencilAlt, faPlusCircle, faSpinner, faTimes } from "@fortawesome/free-solid-svg-icons";
import { mapState } from "vuex";

const log = log2("AccessControl");

library.add(faPencilAlt, faTimes, faPlusCircle, faSpinner);
export default {
    name: "AccessControl",
    components: {
        CreateButton,
        SupsisButton,
        SupsisTable,
        MultiContent,
        ActionEdit,
        ActionDelete,
        Pagination,
        Modal2,
    },
    computed: {
        ...mapState({
            user: (state) => state.auth.user,
        }),
    },
    data() {
        return {
            loading: false,
            editMode: false,
            searchText: undefined,
            cols: () => [
                {
                    field: "ipAddress",
                    key: "ipAddress",
                    title: "IP",
                    renderBodyCell: ({ row }) => {
                        return row.ipAddress;
                    },
                },
                {
                    field: "description",
                    key: "description",
                    title: this.$t("message.description"),
                    renderBodyCell: ({ row }) => {
                        return row.description;
                    },
                },
                {
                    align: "right",
                    field: "actionsSlot",
                    key: "actionsSlot",
                    title: this.$t("message.transactions"),
                    fixed: "right",
                    renderBodyCell: ({ row }) => {
                        return (
                            <div class="d-flex w-100 justify-content-end">
                                <a-button
                                    className="actionButton d-flex align-items-center"
                                    on-click={() => this.remove(row._id)}
                                >
                                    <ActionDelete />
                                </a-button>
                            </div>
                        );
                    },
                },
            ],
            isModalShow: false,
            form: {
                ipAddress: "",
                description: "",
            },
            data: [],
        };
    },
    methods: {
        takeIpAddress() {
            this.form.ipAddress = this.user.lastLoginIPAddress;
        },
        showModal() {
            this.isModalShow = true;
        },
        hideModal() {
            this.isModalShow = false;
        },
        showModalWithoutEdit() {
            this.editMode = false;
            this.showModal();
        },
        getFilteredRows() {
            const items = this.searchText
                ? this.data.filter(
                      (x) =>
                          x.ipAddress.toLowerCase().includes(this.searchText.toLowerCase()) ||
                          x.description.toLowerCase().includes(this.searchText.toLowerCase())
                  )
                : this.data;
            return items;
        },
        onSearch(value) {
            log("onSearch", value);
            this.searchText = value;
        },
        get() {
            this.isBusy = true;
            WHITE_LIST_API.getWhiteList()
                .then((list) => {
                    this.data = list;
                })
                .finally(() => {
                    this.isBusy = false;
                });
        },
        remove(id) {
            this.$dialog
                .confirm(this.$t("settings.deleteWhiteListTitle"), {
                    okText: this.$t("message.continue"),
                    cancelText: this.$t("message.cancel"),
                })
                .then(() => {
                    WHITE_LIST_API.removeWhiteList(id)
                        .then((x) => {
                            this.data = this.data.filter((y) => y._id !== id);
                            this.$toasted.show(this.$t("settings.whiteListDeletedSuccessfully"), {
                                duration: 3000,
                                position: "bottom-center",
                            });
                        })
                        .catch((err) => {
                            this.$toasted.error(this.$t("settings.whiteListDeletedFailed"), {
                                duration: 3000,
                                position: "bottom-center",
                            });
                        });
                });
        },
        handleSave() {
            if (this.editMode) {
            } else {
                WHITE_LIST_API.addWhiteList(this.form)
                    .then((data) => {
                        this.$toasted.show(this.$t("settings.whiteListAddedSuccessfully"), {
                            duration: 3000,
                            position: "bottom-center",
                        });
                        this.data = [...this.data, data];
                        this.form = {
                            ipAddress: "",
                            description: "",
                        };
                        this.hideModal();
                    })
                    .catch((err) => {
                        console.log(err);
                        this.$toasted.error(this.$t("settings.whiteListAddedFailed"), {
                            duration: 3000,
                            position: "bottom-center",
                        });
                    });
            }
        },
    },
    mounted() {
        this.get();
    },
};
</script>

<style lang="scss">
#white-list-form {
    .ip-address {
        width: 100%;
        display: flex;
        align-items: center;
        gap: 10px;
        .supsis-button {
            white-space: nowrap;
            min-width: fit-content;
        }
    }
}
#white-list {
    .search-input {
        width: 200px;
    }
    .ip-address {
        width: 100%;
        display: flex;
        align-items: center;
        gap: 10px;
        .supsis-button {
            white-space: nowrap;
        }
    }
    .form-group {
        margin-bottom: 20px;
    }
    .title {
        font-size: 16px; font-weight: bold; color: #333;
        margin-right: 8px;
    }
}
</style>
